import React from "react";
import { PropagateLoader } from "react-spinners";

export default function Component() {
  return (
    <div
      style={{ display: "flex", justifyContent: "center", padding: "25px 0" }}
    >
      <PropagateLoader color="#14997e" />
    </div>
  );
}
